import CenteredContent from '@picsart/rc/old/CenteredContent';

import useStyles from './styles';

function HowToIconsSkeleton() {
  const styles = useStyles();
  return (
    <CenteredContent>
      <div className={styles.root}>
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonContent}>
          <i className="skeleton" />
          <i className="skeleton" />
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonBtn}>
          <i className="skeleton" />
        </div>
      </div>
    </CenteredContent>
  );
}

export default HowToIconsSkeleton;
